import { combineReducers } from 'redux';


const defaultLoginParams = {
  loginStage: '',
  successfulLogin: false,
  failedLogin: false,
  requestLogin: false,
  requestLogout: false,
  successfulLogout: false,
  failureMessage: '',
}


function params(state = defaultLoginParams, action) {
  if (action.type === 'LOGIN_REQUEST') {
      return {...state,
        loginStage: 'pending',
        requestLogin: true,
        failedLogin: false,
        successfulLogout: false,
      }
  }   if (action.type === 'LOGIN_SUCCESS') {
    return {...state,
      loginStage: 'success',
      requestLogin: false,
      successfulLogin: true,
      successfulLogout: false,
    }
  }
  if (action.type === 'LOGIN_FAILURE') { 
    return {...state, 
      loginStage: 'error',
      failedLogin: true,
      requestLogin : false,
      failureMessage: action.payload,
    }
  } 
  if (action.type === 'LOGOUT_REQUEST') { 
    return {...state, 
      requestLogout:true
    }
  }if(action.type === 'LOGOUT_SUCCESS'){
    return {...state,
      successfulLogin: false,
      failedLogin: false,
      requestLogin: false,
      requestLogout: false,
      successfulLogout: true,
      failureMessage: '',
    }
  }
  if (action.type === 'RESET_DATA') {
    return { ...defaultLoginParams }
  }
  return state
}

const login = combineReducers({
    params
});

export default login;

